import React, { useEffect, useState } from 'react';
import './Pagination.scss';

function Pagination({ total, limit, page, setPage }) {
    const [numPages, setNumPages] = useState(1);
    const [inputNo, setInputNo] = useState(page);

    const paginationLimit = 7;

    useEffect(() => {
        setNumPages(Math.ceil(total / limit));
    }, [total, limit]);

    useEffect(() => {
        setInputNo(page);
    }, [page]);

    const firstNum = Math.floor((page - 1) / paginationLimit) * paginationLimit + 1;
    const lastNum = Math.min(firstNum + paginationLimit - 1, numPages);

    const onChangeInput = (e) => {
        e.preventDefault();
        const value = parseInt(e.target.value);
        if (isNaN(value)) return;
        if (value < 1) {
            setInputNo(1);
        } else if (value > numPages) {
            setInputNo(numPages);
        } else {
            setInputNo(value);
        }
    };

    return (
        <nav className='paginationNav'>
            <button
                onClick={() => setPage(page - 1)}
                disabled={page === 1}
                aria-label="이전 페이지"
            >
                &lt;
            </button>

            {/* 페이지 버튼들 */}
            {Array.from({ length: lastNum - firstNum + 1 }, (_, i) => {
                const pageNum = firstNum + i;
                return (
                    <button
                        key={pageNum}
                        onClick={() => setPage(pageNum)}
                        aria-current={page === pageNum ? "page" : null}
                        aria-label={`페이지 ${pageNum}`}
                    >
                        {pageNum}
                    </button>
                );
            })}

            <button
                onClick={() => setPage(page + 1)}
                disabled={page === numPages}
                aria-label="다음 페이지"
            >
                &gt;
            </button>

            {/* 직접 입력 */}
            <div className='goToBtnsArea'>
                <div className='inputArea'>
                    <input
                        type="number"
                        value={inputNo}
                        onChange={onChangeInput}
                        min={1}
                        max={numPages}
                        style={{ textAlign: 'center' }}
                    />
                    <span>/</span>
                    <p>{numPages}</p>
                </div>
                <button
                    style={{
                        backgroundColor: '#0A2B83',
                        borderRadius: '5px',
                        padding: '4px 8px',
                        color: 'white'
                    }}
                    onClick={() => {
                        if (!isNaN(inputNo) && inputNo >= 1 && inputNo <= numPages) {
                            setPage(inputNo);
                        }
                    }}
                >
                    GO
                </button>
            </div>
        </nav>
    );
}

export default Pagination;
